import { useRef, useEffect } from "react";
import ModuleService from "../../../common/util/ModuleService";
import TaskService from "../../../common/util/TaskService";
import { getJobId } from "../../../common/util/appUtils";

export const useNotificationDataRef = () => {
  const allTaskRef = useRef([]);
  const allJobsRef = useRef([]);
  const cacheDealsRef = useRef([]);

  useEffect(() => {
    const getAllResourse = () => {
      ModuleService.GetModuleList("Deals")
        .then((result) => {
          cacheDealsRef.current = result.data || [];
        })
        .catch(console.error);
    };

    const getJobsByProjectId = (pid) => {
      TaskService.GetJobsByProjectId(pid)
        .then((result) => {
          if (result) {
            for (let i = 0; i < result.length; i++) {
              result[i].name = result[i].projectName + "-" + result[i].jobName;
            }
            allJobsRef.current = result;
          } else {
            allJobsRef.current = [];
          }
        })
        .catch(console.error)
        .finally(() => {
          getAllTask();
        });
    };

    const getAllTask = () => {
      TaskService.GetMyTasks()
        .then((result) => {
          for (let i = 0; i < result.length; i++) {
            result[i].JobId = getJobId(result[i].id_string, allJobsRef.current);
          }
          allTaskRef.current = result;
        })
        .catch(console.error);
    };

    getAllResourse();
    getJobsByProjectId("");

  }, []);

  return { allTaskRef, allJobsRef, cacheDealsRef };
};
